// Camera types for Strapi API
export type CameraStatus = "active" | "inactive";
export type InstallationType = "roof" | "facade" | "cabin";

export interface Camera {
  id: number;
  documentId: string;
  name: string;
  streamUrl: string;
  cameraStatus: CameraStatus;
  address: string | null;
  objectName: string | null;
  installationType: InstallationType;
  // createdAt: string; // ISO дата
  // updatedAt: string; // ISO дата
  // publishedAt: string; // ISO дата
}

// Video player types
export interface VideoPlayerProps {
  streamUrl?: string;
  autoPlay?: boolean;
  showStatus?: boolean;
  status?: "active" | "inactive";
  onError?: (error: Error) => void;
  onLoad?: () => void;
}

// Modal types
export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

// Header types
export interface HeaderProps {
  currentPage?: "cameras" | "grid";
  onNavigate?: (page: "cameras" | "grid") => void;
  onLogout?: () => void;
}

// Grid types
export interface GridCell {
  camera: Camera | null;
  index: number;
}

export type GridTemplate = "2x2" | "3x3" | "4x4";

// API types
export interface LoginRequest {
  identifier: string;
  password: string;
}

export interface LoginResponse {
  jwt: string;
  user: {
    id: number;
    username: string;
    email: string;
  };
}

export interface ApiError {
  message: string;
  code?: string;
}

// Strapi API Response wrapper
export interface StrapiResponse<T> {
  data: T;
  meta?: {
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

// Demo data for fallback when API is unavailable
export const demoCameras: Camera[] = [
  {
    id: 1,
    documentId: "test",
    name: "Камера 1 - Главный вход",
    address: "ул. Ленина, 42",
    objectName: "Бизнес-центр «Аркада»",
    cameraStatus: "active",
    installationType: "facade",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    id: 2,
    documentId: "test",
    name: "Камера 2 - Парковка",
    address: "ул. Ленина, 42",
    objectName: "Бизнес-центр «Аркада»",
    cameraStatus: "active",
    installationType: "roof",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    id: 3,
    documentId: "test",
    name: "Камера 3 - Ресепшен",
    address: "ул. Садовая, 15",
    objectName: "Торговый центр «Галерея»",
    cameraStatus: "inactive",
    installationType: "facade",
    streamUrl: "",
  },
  {
    id: 4,
    documentId: "test",
    name: "Камера 4 - Склад",
    address: "пр. Победы, 88",
    objectName: "Логистический центр",
    cameraStatus: "active",
    installationType: "cabin",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    id: 5,
    documentId: "test",
    name: "Камера 5 - КПП",
    address: "пр. Победы, 88",
    objectName: "Логистический центр",
    cameraStatus: "active",
    installationType: "facade",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    id: 6,
    documentId: "test",
    name: "Камера 6 - Погрузочная зона",
    address: "пр. Победы, 88",
    objectName: "Логистический центр",
    cameraStatus: "inactive",
    installationType: "roof",
    streamUrl: "",
  },
  {
    id: 7,
    documentId: "test",
    name: "Камера 7 - Холл",
    address: "ул. Новая, 10",
    objectName: "ЖК «Новые горизонты»",
    cameraStatus: "active",
    installationType: "cabin",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    id: 8,
    documentId: "test",
    name: "Камера 8 - Лифт",
    address: "ул. Новая, 10",
    objectName: "ЖК «Новые горизонты»",
    cameraStatus: "active",
    installationType: "cabin",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    id: 9,
    documentId: "test",
    name: "Камера 9 - Двор",
    address: "ул. Новая, 10",
    objectName: "ЖК «Новые горизонты»",
    cameraStatus: "inactive",
    installationType: "roof",
    streamUrl: "",
  },
];
